module.exports = __webpack_public_path__ + "img/Lesotho.5479edd6.svg";